import { useState } from "react";
import {
  FindPasswordVerificationResponse,
  ResetPasswordResponse,
} from "../../types/auth";
import { apiClient } from "../../utils/api";

export const useFindPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [verificationResult, setVerificationResult] =
    useState<FindPasswordVerificationResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isVerified, setIsVerified] = useState(false);

  const verifyIdAndPhone = async (id: string, phoneNumber: string) => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await apiClient.post<FindPasswordVerificationResponse>(
        "/api/v1/auth/sms/pw/verification",
        {
          contact_hp: phoneNumber,
          id: id,
        }
      );

      if (response.status) {
        setVerificationResult(response.data);
        if (response.data.unmatched) {
          setError("아이디 또는 전화번호가 일치하지 않습니다.");
        } else {
          setError(null);
        }
      }
      return response.data;
    } catch (error) {
      setError("비밀번호 찾기 중 오류가 발생했습니다. 다시 시도해주세요.");
      console.error("Find password verification error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const verifyCode = (inputCode: string) => {
    setError(null);
    if (!verificationResult?.authcode) {
      setError("인증번호가 만료되었습니다. 다시 시도해주세요.");
      return false;
    }

    if (inputCode === verificationResult.authcode) {
      setIsVerified(true);
      return true;
    } else {
      setError("인증번호가 일치하지 않습니다. 다시 확인해주세요.");
      return false;
    }
  };

  const resetPassword = async (
    id: string,
    phoneNumber: string,
    newPassword: string
  ) => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await apiClient.post<ResetPasswordResponse>(
        "/api/v1/auth/reset/password",
        {
          contact_hp: phoneNumber,
          x_id: id,
          new_app_key: newPassword,
        }
      );

      console.log(response);
      if (response.data.status) {
        return true;
      } else {
        if (response.data.unmatch_platform) {
          setError("소셜 로그인 계정은 비밀번호를 재설정할 수 없습니다.");
        } else if (response.data.unmatch_user) {
          setError("일치하는 사용자 정보를 찾을 수 없습니다.");
        } else {
          setError("비밀번호 재설정에 실패했습니다. 다시 시도해주세요.");
        }
        return false;
      }
    } catch (error) {
      setError("서버 오류가 발생했습니다. 다시 시도해주세요.");
      console.error("Reset password error:", error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const resetVerification = () => {
    setVerificationResult(null);
    setError(null);
    setIsVerified(false);
  };

  return {
    isLoading,
    verificationResult,
    verifyIdAndPhone,
    verifyCode,
    resetPassword,
    error,
    isVerified,
    resetVerification,
  };
};
